/**
 * Runs async jobs with at most `max` in flight. The analytics pages fire one request per chart;
 * sending ~20 heavy aggregations at once made the database and the API queue all of them, so
 * every chart waited for the slowest. A small window lets the first charts render right away.
 *
 *   const limit = createLimiter(4)
 *   limit(() => this.listGenders(...))
 */
export function createLimiter(max) {
    let active = 0
    const queue = []

    const next = () => {
        if (active >= max || queue.length === 0) return
        active++
        const { job, resolve, reject } = queue.shift()
        Promise.resolve()
            .then(job)
            .then(resolve, reject)
            .finally(() => {
                active--
                next()
            })
    }

    return job => new Promise((resolve, reject) => {
        queue.push({ job, resolve, reject })
        next()
    })
}
